export function ManagementIcon() {
  return (
    <svg
      className="omni-image"
      preserveAspectRatio="xMidYMid meet"
      viewBox="26 47.01 143 111.294"
      height="130"
      width="130"
      role="presentation"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <style>{`
          #comp-jzmhemwt svg [data-color='1'] { fill: #EAEAD9; }
          #comp-jzmhemwt svg [data-color='2'] { fill: #A68E68; }
        `}</style>
      </defs>

      <g fillRule="evenodd">
        <path
          fill="#EAEAD9"
          d="M51.606 105.393c5.858 5.858 5.858 15.356 0 21.213-5.858 5.858-15.355 5.858-21.213 0-5.858-5.857-5.858-15.355 0-21.213 5.858-5.858 15.355-5.858 21.213 0z"
          data-color="1"
        />
        <path
          fill="#EAEAD9"
          d="M164.606 75.393c5.858 5.858 5.858 15.356 0 21.214-5.858 5.857-15.355 5.857-21.213 0-5.858-5.858-5.858-15.356 0-21.214 5.858-5.857 15.355-5.857 21.213 0z"
          data-color="1"
        />
        <path
          fill="#B87E58"
          fillRule="nonzero"
          d="M69.367 158.304l-3.737-2.076L126.325 47.01l3.737 2.079-60.695 109.214z"
          data-color="2"
        />
      </g>
    </svg>
  );
}